<template>
  <div class="brand">
    <ul>
      <li v-for="(item, index) of brandList" :key="index">
        <router-link to="">
          <div><img :src="item.img" /></div>
          <div class="content">
            <div class="title">{{ item.title }}</div>
            <div class="">{{ item.content }}</div>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: [
    'brandList'
  ],
  data () {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.brand {
  ul {
    li {
      margin: 20px 0;
      a {
        border: 1px solid #eeeeee;
        padding: 10px;
        width: 730px;
        img {
          width: 250px;
          height: 200px;
        }
        .content {
          height: 200px;
          text-align: left;
          .title {
            font-size: 25px;
            margin-bottom: 5px;
            padding-bottom: 5px;
            border-bottom: 1px solid #eeeeee;
          }
        }
        @extend.flex-box;
        font-size: 0.12rem;
      }
    }
  }
}
</style>
